<template>
    <div class="d-content">
        <keep-alive>
            <div class="main-container">
                <h3 class="reportHeading">Select Direct Pay Bank Type:</h3>
                <div class="twoColumnGridDashboard marginbottom-5px">
                    <div class="ReportContainer" v-for="(nav, index) in navList" :key="index" @click="navigatePopup(nav)">
                        <div class="reportIcon">
                            <img :src="nav.imgUrl" alt="">
                        </div>
                        <div class="reportTitle">
                            <h3>{{nav.name }}</h3>
                            <p>{{nav.textContent}}</p>
                        </div>
                        <div class="reportArrow">
                            <img src="@/assets/arrowReport.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </keep-alive>
    </div>
</template>
<script>
export default{
    data(){
        return{
            navList: [
                {
                    name: "HSBC Direct pay",
                    imgUrl: require('@/assets/directPay/directPayHsbc.svg'),
                    textContent: "HSBC direct deposit is the electronic transfer of net pay from an employer's financial institution to an employee's personal bank account."
                },
                // {
                //     name: "SBI Direct Pay",
                //     imgUrl: require('@/assets/directPay/directPaySbi.svg'),
                //     textContent:"SBI  direct deposit is the electronic transfer of net pay from an employer's financial institution to an employee's personal bank account."
                // },
                // {
                //     name: "ICICI Direct Pay",
                //     imgUrl: require('@/assets/directPay/directPayICICI.svg'),
                //     textContent:"ICICI direct deposit is the electronic transfer of net pay from an employer's financial institution to an employee's personal bank account."
                // },
                // {
                //     name: "Yes Bank Direct Pay",
                //     imgUrl: require('@/assets/directPay/directPayYes.svg'),
                //     textContent:"YES bank direct deposit is the electronic transfer of net pay from an employer's financial institution to an employee's personal bank account."
                // },
            ],
        }
    },
    methods: {
        navigatePopup(nav){
            try{
              if(nav.name == "HSBC Direct pay"){
              this.$router.push({
                path:`/dashboard/${
          this.$route.params.entity_index ? this.$route.params.entity_index : 0
        }/directPay/hsbcDirectPay`
              })
            }
            }catch(err){

            }
        }
    },
}
</script>
<style lang="scss" scoped>
.reportHeading {
        margin-bottom: 30px;
        color: #777777;
    }
.ReportContainer {
        width: 100%;
        padding: 10px 20px 10px 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 8px;
        border: solid 1px #F0F0F0;
        background-color: #f5f5f5;
        cursor: pointer;
    }
    .reportTitle {
        width: 80%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: start;
        margin-left: 20px;
        margin-right: 20px;
        // align-self: start;
    }
    .reportTitle>h3 {
        color: #34C0BD;
        margin-bottom: 5px;
    }

    .reportTitle>p {
        color: #777777;
        margin: 0;
    }

    .reportArrow > img{
        align-self: end;
    }
</style>